<template>
 <div class="md:hidden ">
  <MobileSearchBar />
</div>
  <div class="min-h-screen bg-gray-50">
      <div  class="w-full mb-6">
      <img
        :src="getLogo(commissionBanner)"
         alt="Commission Transfer Banner"
        class="w-full max-h-[80vh] aspect-[3/1] sm:aspect-[3/1] md:aspect-[3/1] lg:aspect-[4/1] md:object-cover sm:object-none object-center rounded-b-lg shadow"
        @error="handleImageError"
      />
    </div>
    <!-- Banner Image -->


    <!-- Main Content -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 py-12">
      <!-- Page Header -->
      <div class="text-center mb-12">
        <h1 class="text-4xl font-extrabold text-gray-900 mb-4">
          {{ $t('commission.title') }}
        </h1>
        <p class="text-lg text-gray-600 max-w-2xl mx-auto">
          {{ $t('commission.subtitle') }}
        </p>
      </div>

      <!-- Commission Content -->
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <!-- Calculator Section -->
        <div class="bg-white p-8 rounded-lg shadow-md lg:col-span-1">
          <h2 class="text-2xl font-bold text-gray-800 mb-6">
            {{ $t('commission.calculatorTitle') }}
          </h2>
          
          <div class="space-y-6">
            <div>
              <label class="block text-lg font-medium text-gray-700 mb-2">
                {{ $t('commission.amountLabel') }}
              </label>
              <input
                v-model.number="amount"
                type="number"
                min="0"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                placeholder="Enter amount"
              />
              
              <div class="mt-4 space-y-2">
                <p class="text-gray-600">
                  {{ $t('commission.rate') }}: 
                  <span class="font-semibold text-teal-600">{{ commissionRate }}%</span>
                </p>
                <p class="text-gray-600">
                  {{ $t('commission.calculated') }}:
                  <span class="font-semibold text-teal-600">
                    {{ calculatedCommission }} {{ $t('commission.currency') }}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Banks Section -->
        <div class="bg-white p-8 rounded-lg shadow-md lg:col-span-2">
          <h2 class="text-2xl font-bold text-gray-800 mb-6">
            {{ $t('commission.banksTitle') }}
          </h2>
          
          <div class="overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {{ $t('commission.logo') }}
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {{ $t('commission.bankName') }}
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {{ $t('commission.iban') }}
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {{ $t('commission.accountName') }}
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="bank in banks" :key="bank.id" class="hover:bg-gray-50">
                  <td class="px-6 py-4 whitespace-nowrap">
                    <img :src="getLogo(bank.logo)" class="w-12 h-12 object-contain" />
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {{ bank.name }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ bank.iban }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ bank.account_holder_name }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Transfer Form -->
        <div class="bg-white p-8 rounded-lg shadow-md lg:col-span-3">
          <h2 class="text-2xl font-bold text-gray-800 mb-6">
            {{ $t('commission.formTitle') }}
          </h2>
          
          <form @submit.prevent="submitForm" class="space-y-6">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
  <label class="block text-sm font-medium text-gray-700 mb-1">
    {{ $t('commission.userName') }}
  </label>
  <input 
    v-model="form.user_name" 
    type="text" 
  class="w-full h-12 px-4 py-2 text-base border border-gray-300 rounded-lg focus:ring-teal-500 focus:border-teal-500"
  />
  <p v-if="errors.user_name" class="text-red-500 text-sm mt-1">{{ errors.user_name }}</p>
</div>
              
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  {{ $t('commission.amount') }}
                </label>
                <input 
                  v-model="form.amount" 
                  type="number" 
  class="w-full h-12 px-4 py-2 text-base border border-gray-300 rounded-lg focus:ring-teal-500 focus:border-teal-500"
                />
                <p v-if="errors.amount" class="text-red-500 text-sm mt-1">{{ errors.amount }}</p>
              </div>
              
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  {{ $t('commission.bank') }}
                </label>
                <select 
                  v-model="form.bank_id" 
  class="w-full h-12 px-4 py-2 text-base border border-gray-300 rounded-lg focus:ring-teal-500 focus:border-teal-500"
                >
                  <option value="" disabled>{{ $t('commission.chooseBank') }}</option>
                  <option v-for="bank in banks" :value="bank.id" :key="bank.id">
                    {{ bank.name }}
                  </option>
                </select>
                <p v-if="errors.bank_id" class="text-red-500 text-sm mt-1">{{ errors.bank_id }}</p>
              </div>
              
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  {{ $t('commission.senderName') }}
                </label>
                <input 
                  v-model="form.sender_name" 
                  type="text" 
  class="w-full h-12 px-4 py-2 text-base border border-gray-300 rounded-lg focus:ring-teal-500 focus:border-teal-500"
                />
                <p v-if="errors.sender_name" class="text-red-500 text-sm mt-1">{{ errors.sender_name }}</p>
              </div>
              
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  {{ $t('commission.email') }}
                </label>
                <input 
                  v-model="form.email" 
                  type="email" 
  class="w-full h-12 px-4 py-2 text-base border border-gray-300 rounded-lg focus:ring-teal-500 focus:border-teal-500"
                />
                <p v-if="errors.email" class="text-red-500 text-sm mt-1">{{ errors.email }}</p>
              </div>
              
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  {{ $t('commission.adNumber') }}
                </label>
                <input 
                  v-model="form.ad_number" 
                  type="text" 
  class="w-full h-12 px-4 py-2 text-base border border-gray-300 rounded-lg focus:ring-teal-500 focus:border-teal-500"
                />
                <p v-if="errors.ad_number" class="text-red-500 text-sm mt-1">{{ errors.ad_number }}</p>
              </div>
            </div>
            
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">
                {{ $t('commission.note') }}
              </label>
              <textarea 
                v-model="form.note" 
                rows="4" 
                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-teal-500 focus:border-teal-500"
              ></textarea>
              <p v-if="errors.note" class="text-red-500 text-sm mt-1">{{ errors.note }}</p>
            </div>
            
            <div class="flex justify-end">
              <button 
                type="submit" 
                class="px-6 py-3 bg-teal-600 text-white font-medium rounded-lg hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500 transition-colors"
              >
                {{ $t('commission.submit') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import Swal from "sweetalert2";
import MobileSearchBar from "@/components/MobileSearchBar.vue";
export default {
  name: "CommissionTransfer",
  data() {
    return {
      commissionBanner: "",
      banks: [],
      commissionRate: 0,
      amount: 0,
      form: {
        user_name: "",
        amount: "",
        bank_id: "",
        sender_name: "",
        email: "",
        ad_number: "",
        note: "",
      },
       errors: {},
    };
  },
  computed: {
    calculatedCommission() {
      return ((this.amount || 0) * this.commissionRate / 100).toFixed(2);
    },
  },
  created() {
    api.get("/v1/commission/banks-info").then((res) => {
      this.banks = res.data.banks;
      this.commissionRate = res.data.commission_rate;
       this.commissionBanner = res.data.commission_banner;
    });
  },
  methods: {
    validateForm() {
  const errors = {};
  const lang = this.$i18n.locale;

  if (!this.form.user_name) {
    errors.user_name = lang === 'ar' ? 'يرجى إدخال اسم المستخدم' : 'Please enter your name';
  }

  if (!this.form.amount || this.form.amount <= 0) {
    errors.amount = lang === 'ar' ? 'يرجى إدخال مبلغ صالح' : 'Please enter a valid amount';
  }

  if (!this.form.bank_id) {
    errors.bank_id = lang === 'ar' ? 'يرجى اختيار البنك' : 'Please select a bank';
  }

  if (!this.form.sender_name) {
    errors.sender_name = lang === 'ar' ? 'يرجى إدخال اسم المُرسِل' : 'Please enter sender name';
  }

  if (!this.form.email || !/\S+@\S+\.\S+/.test(this.form.email)) {
    errors.email = lang === 'ar' ? 'يرجى إدخال بريد إلكتروني صحيح' : 'Please enter a valid email';
  }

  if (!this.form.ad_number) {
    errors.ad_number = lang === 'ar' ? 'يرجى إدخال رقم الإعلان' : 'Please enter ad number';
  }

  this.errors = errors;
  return Object.keys(errors).length === 0;
},
    getLogo(path) {
       return path ? `https://admin.from-malk.com/storage/${path}` : "";
    },
    submitForm() {
        if (!this.validateForm()) {
    return;
  }
      api
        .post("/v1/commission/transfer", this.form)
        .then(() => {
          Swal.fire({
            icon: "success",
            title: this.$t("commission.successTitle"),
            text: this.$t("commission.successMessage"),
            confirmButtonText: this.$t("commission.ok"),
          });
          this.resetForm();
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: this.$t("commission.errorTitle"),
            text: this.$t("commission.errorMessage"),
          });
        });
    },
    resetForm() {
      this.form = {
        user_name: "Guest",
        amount: "",
        bank_id: "",
        sender_name: "",
        email: "",
        ad_number: "",
        note: "",
      };
    },
  },
  components: {
    MobileSearchBar,
  },
};
</script>